import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    connect() {
        this.restoreSelections()
    }

    restoreSelections() {
        const state = window.financeReconciliation
        if (!state) return

        const matches = state.matches || []

        this.element.querySelectorAll("input[type='checkbox']").forEach(cb => {
            const id = cb.dataset.id
            const type = cb.dataset.type

            const exists = matches.some(
                m => String(m.id) === id && m.type === type
            )

            cb.checked = exists

            const amountInput = this.element.querySelector(
                `input[type="number"][data-id="${id}"][data-type="${type}"]`
            )

            if (amountInput && exists) {
                const match = matches.find(
                    m => String(m.id) === id && m.type === type
                )
                amountInput.value = match.amount
            }
        })
    }

    toggle(event) {
        console.log("toggle")
        const el = event.currentTarget

        const item = {
            type: el.dataset.type,
            id: el.dataset.id,
            title: el.dataset.title,
            subtitle: el.dataset.subtitle,
            amount: parseFloat(el.dataset.amount)
        }

        if (el.checked) {
            this.dispatch("add", { detail: item })
        } else {
            this.dispatch("remove", { detail: item })
        }
    }

    amountChanged(event) {
        const input = event.currentTarget

        const item = {
            id: input.dataset.id,
            type: input.dataset.type,
            amount: parseFloat(input.value)
        }

        this.dispatch("updateAmount", { detail: item })
    }

    untick(event) {
        const item = event.detail

        const id = CSS.escape(String(item.id))
        const type = CSS.escape(item.type)

        const amountInput = this.element.querySelector(
            `input[type="number"][data-key="${item.type}-${item.id}"]`
        )

        if (amountInput) amountInput.value = amountInput.defaultValue

        const checkbox = this.element.querySelector(
            `input[type="checkbox"][data-key="${item.type}-${item.id}"]`
        )

        if (checkbox) checkbox.checked = false
    }
}
